import { render, staticRenderFns } from "./PermissionTemplateForm.vue?vue&type=template&id=7bae1a8c&"
import script from "./PermissionTemplateForm.vue?vue&type=script&lang=js&"
export * from "./PermissionTemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./PermissionTemplateForm.vue?vue&type=style&index=0&id=7bae1a8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports